import ResetButton from '@/assets/img/button_signature_reset@2x.png';
import React, { forwardRef, HTMLAttributes, useRef } from 'react';
import ReactSignatureCanvas from 'react-signature-canvas';
import styled from 'styled-components';

const SignatureContainer = styled.div`
  position: relative;
  width: 100%;
  // height: 240px;
  border: 1px solid #e5e6e8;
  canvas {
    display: block;
    max-width: 100%;
  }
`;
const SignatureReset = styled.button`
  width: 22px;
  height: 20px;
  position: absolute;
  right: 12px;
  top: 12px;
  margin: 0 !important;
  img {
    max-width: 100%;
  }
`;

interface SignatureProps
  extends Omit<HTMLAttributes<HTMLDivElement>, 'onChange'> {
  onChange: (value: string) => void;
  name: string;
}

const Signature = forwardRef<HTMLButtonElement, SignatureProps>(
  ({ onChange, name, ...props }, ref) => {
    const sigRef = useRef<ReactSignatureCanvas>(null);

    const handleRestSignature = () => {
      sigRef.current?.clear();
      if (sigRef.current) {
        onChange(``);
      }
    };

    const handleEnd = () => {
      if (sigRef.current) {
        onChange(sigRef.current.toDataURL());
      }
    };

    return (
      <SignatureContainer {...props}>
        <ReactSignatureCanvas
          ref={sigRef}
          canvasProps={{ width: 544, height: 240 }}
          onEnd={handleEnd}
        />
        <SignatureReset
          ref={ref}
          name={name}
          type="button"
          onClick={() => {
            handleRestSignature();
          }}
        >
          <img src={ResetButton} alt="서명 지우기" />
        </SignatureReset>
      </SignatureContainer>
    );
  },
);
export default Signature;
